import type { IRecordType } from '@app/types';

const MASKED_LAST_NAME = '*********';
const MASKED_PHONE = '**********';
const MASKED_EMAIL = '*****@****.**';

interface GetRecordDisplayIdentityParams {
  record: Pick<IRecordType, 'Email' | 'NameFirst' | 'NameLast' | 'Phone'>;
  canShowContacts: boolean;
  fallbackClientName?: string;
  fallbackPhone?: string;
}

interface RecordDisplayIdentity {
  clientName: string;
  email?: string;
  phone?: string;
}

export const getRecordDisplayIdentity = ({
  record,
  canShowContacts,
  fallbackClientName,
  fallbackPhone,
}: GetRecordDisplayIdentityParams): RecordDisplayIdentity => {
  const displayLastName = canShowContacts
    ? record.NameLast
    : record.NameLast
    ? MASKED_LAST_NAME
    : record.NameLast;

  const composedClientName = [record.NameFirst, displayLastName]
    .filter(Boolean)
    .join(' ')
    .trim();

  const clientName =
    composedClientName || (canShowContacts ? fallbackClientName || '' : '');

  const phone = canShowContacts
    ? record.Phone || fallbackPhone || undefined
    : record.Phone || fallbackPhone
    ? MASKED_PHONE
    : undefined;

  const email = canShowContacts
    ? record.Email || undefined
    : record.Email
    ? MASKED_EMAIL
    : undefined;

  return {
    clientName,
    email,
    phone,
  };
};
